import { createReducer } from '@reduxjs/toolkit';
import { getAllCompetenceTemp } from './actions';

//actions
const initialState = {
  list: [],
};

export default createReducer(initialState, builder =>
  builder.addCase(getAllCompetenceTemp, (state, action) => {
    state.list = action.payload;
  })
);
